import { Dialog } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import MuiAddAPhoto from '@material-ui/icons/AddAPhoto';
import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';

type Props = {
  open: boolean;
  setOpen: (open: boolean) => void;
  onUploadComplete: (fileName: string) => void;
  loading: boolean;
};
const Status = {
  uploading: 'Uploading image...',
  errorMultipleFiles: "Can't upload more than one file",
  empty: '',
};

export const PlexImageInput = ({ loading, open, setOpen, onUploadComplete }: Props): React.ReactElement => {
  const classes = useStyles();
  const [status, setStatus] = useState<string>(Status.empty);
  const onDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles.length > 1) {
        setStatus(Status.errorMultipleFiles);
        return;
      }
      const formData = new FormData();
      for (let i = 0; i < acceptedFiles.length; i++) {
        formData.append(`file${i}`, acceptedFiles[i], acceptedFiles[i].name);
      }
      setStatus(Status.uploading);
      fetch('/api/upload', { method: 'POST', body: formData })
        .then((res) => res.json())
        .then((savedFiles) => {
          setOpen(false);
          onUploadComplete(savedFiles[0].gcsLocation);
        });
    },
    [onUploadComplete, setOpen]
  );
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, multiple: false });
  const text = !!status
    ? status
    : loading
    ? 'Saving...'
    : isDragActive
    ? 'Drop the files here ...'
    : 'Drag and drop your avatar here, or click to upload a saved file';
  return (
    <Dialog open={open} onClose={(): void => setOpen(false)}>
      <div {...getRootProps()} className={classes.dropZone}>
        <input {...getInputProps()} />
        <MuiAddAPhoto className={classes.icon} />
        <p>{text}</p>
      </div>
    </Dialog>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dropZone: {
      width: 500,
      height: 300,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
    },
    icon: {
      height: 100,
      width: 100,
    },
  })
);
